<template>
  <div class="flex flex-wrap">
    <div class="w-full lg:w-12/12 px-4">
      <Form 
      pageType="Add"
      :onSubmit="onSubmit"
      :alertType="this.alertType"
      :alertMessage="this.alertMessage"
      :clientProps="client"
      />
    </div>
  </div>

</template>
<script>
import { UseAppStore } from '@/stores/AppStore';
import Form from "@/views/admin/clients/Form.vue";
import ClientDataService from "@/services/ClientDataService";

export default {
  setup(){
    const appStore = UseAppStore();
    appStore.resetBreadcrumbs();
    appStore.putBreadcrumbs("dashboard", "Dashboard", "/admin/dashboard")
    appStore.putBreadcrumbs("client", "Client Management", "/admin/client")
    return {
      appStore
    }
  },
  data(){
    return {
      alertType: '',
      alertMessage: '',
      client: {
          id: null,
          clientName: "",
          authToken: ""
        }
    }
  },
  components: {
    Form
  },
  methods: {
    onSubmit(client) {
      var data = {
            client_name: client.clientName,
            auth_token: client.authToken
          
      };

      console.log(JSON.stringify(data))
      ClientDataService.create(data)
        .then(() => {
          // client.id = response.data.id;
          // console.log(response.data.code_message);            
          // console.log(response.data);            
          this.alertType = 'Success'
          this.alertMessage = 'Client successfuly created'
          this.$router.replace('/admin/clients')
        })
        .catch(e => {
          this.alertType = 'Failed'
          this.alertMessage = e.response.data.code_message
          console.log(e);
        });
    }
  }
};
</script>
